import { ProductPayload, UpdateProductPayload } from "../constants/types";
import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const createProduct = async (payload: any, endpoint: string) => {
  try {
    const response = await api.post(endpoint, payload, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data;
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.error?.type ||
      error.response?.data?.message ||
      error.message ||
      "Failed to create product.";

    throw new Error(errorMessage);
  }
};

export const updateProduct = async (
  payload: UpdateProductPayload,
  endpoint: string,
  id: string
) => {
  try {
    const url = endpoint + id;

    const response = await api.put(url, payload, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Unexpected error:", error);
    throw new Error("Failed to update product.");
  }
};

export const togglePrebookProduct = async (
  id: string,
  display: boolean
): Promise<any> => {
  try {
    const response = await api.patch(
      `/products/toggle/${id}`,
      {
        display,
      },
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Unexpected error while toggling product:", error);
    throw new Error("Failed to update product display toggle.");
  }
};
